import { createContext } from 'react';
import {
    QUERY_KEYS_SECURITY,
    useChartsData
} from '../../../../Common/hooks/useChartsData';
import { useSecurityFiltersContext } from '../../../../Seguranca/Common/Filters/hooks/useSecurityFiltersContext';

export const SpotsChartsDataContext = createContext();

const SpotsChartsDataProvider = ({ children }) => {
    const { filters } = useSecurityFiltersContext();
    const currentYear = new Date().getFullYear();
    const filterParams = {
            year: filters.year?.value || '',
            month: filters.month?.value ? String(Number(filters.month?.value)) : "",
            location: filters.unidade.value,
            city: filters.cidade?.value,
    }

    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_SECURITY.NARCOTICS_QUANTITIES_SPOTS,
            url: 'governanceroom/securitydashboard/productivityData/narcoticQuantities/spots'
        },
        filterParams
    );

    const chartData = {
              spots: data || []
    }

    return (
        <SpotsChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </SpotsChartsDataContext.Provider>
    );
};

export default SpotsChartsDataProvider;
